import { useEffect, useRef } from 'react';

export function useReveal() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    const observe = (node: Element) => {
      if (
        node.classList.contains('reveal') ||
        node.classList.contains('reveal-left') ||
        node.classList.contains('reveal-right')
      ) {
        intersectionObserver.observe(node);
      }
      node.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach((item) =>
        intersectionObserver.observe(item)
      );
    };

    // 초기 스캔
    observe(el);

    // 동적으로 추가되는 .reveal 요소 감지
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            observe(node as Element);
          }
        });
      });
    });

    mutationObserver.observe(el, { childList: true, subtree: true });

    return () => {
      intersectionObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, []);

  return ref;
}